var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgResend = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 4.9071V10.9071H17",
    stroke: "#2E63FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.9071V14.9071H7",
    stroke: "#2E63FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51 9.90712C4.01717 8.4739 4.87913 7.19252 6.01547 6.18254C7.1518 5.17255 8.52547 4.46688 10.0083 4.13138C11.4911 3.79587 13.0348 3.84146 14.4952 4.26389C15.9556 4.68633 17.2853 5.47183 18.36 6.54712L23 10.9071M1 14.9071L5.64 19.2671C6.71475 20.3424 8.04437 21.1279 9.50481 21.5503C10.9652 21.9728 12.5089 22.0184 13.9917 21.6829C15.4745 21.3474 16.8482 20.6417 17.9845 19.6317C19.1209 18.6217 19.9828 17.3403 20.49 15.9071",
    stroke: "#2E63FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resend.155425e1.svg";
export { ForwardRef as ReactComponent };